// extracted by mini-css-extract-plugin
export default {"footlink":"index_footlink_PtaTE","fk_l":"index_fk_l_SJPKy","noBorder":"index_noBorder_CZ3SD","copyright":"index_copyright_teJwc"};